import { Component, inject } from '@angular/core';
import { table, CacTableComponent } from '@controladad/ng-base';
import { AuthStore, cacTableIdCol, cacTableStatusCol, UserApiService } from '@core';

@Component({
  selector: 'lib-admin-users',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './admin-users.component.html',
  styleUrl: './admin-users.component.scss',
})
export class AdminUsersComponent {
  private readonly usersApi = inject(UserApiService);
  private readonly authStore = inject(AuthStore);

  table = table({
    itemsFn: this.usersApi.getAdminAdapter(),
    view: {
      itemName: 'Admin User',
      title: 'Admins',
    },
    columns: {
      id: cacTableIdCol(),
      fullName: {
        label: 'Full Name',
        sortable: 'FullName',
        filterable: 'FullName',
        // transform: (_, row) => getFullName(row),
      },
      username: {
        label: 'Username',
        sortable: true,
        filterable: [
          {
            type: 'contains',
            key: 'Username',
          },
        ],
      },
      email: {
        label: 'Email',
        sortable: true,
        filterable: [
          {
            type: 'contains',
          },
        ],
      },
      status: cacTableStatusCol(),
    },
    actions: this.authStore.isRestrictedAdmin() ? [] : [
      {
        type: 'icon',
        content: 'edit',
        action: (item) => dialog$.adminUser({ user: item }).afterSubmit(),
      },
    ],
    events: this.authStore.isRestrictedAdmin() ? undefined : {
      add: () => dialog$.adminUser({}).afterSubmit(),
    },
  });
}
